
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("c8mrj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aUTn5 = parcelRequire("aUTn5");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $1Q0l6 = parcelRequire("1Q0l6");


var $UNr39 = parcelRequire("UNr39");


var $jln20 = parcelRequire("jln20");


var $cAdj8 = parcelRequire("cAdj8");

const $c8e282bfad3727e4$export$ddc739fc0aea988a = ({ contentId: contentId, content: content, useRovoWidth: useRovoWidth = false })=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsRovoPanelWidth = (0, $hq2Sz.useSetIsRovoPanelWidth)();
    const setInsertStorageFragmentRequestPayload = (0, $hq2Sz.useSetInsertStorageFragmentRequestPayload)();
    const contentLastModifiedTimestamp = (0, $hq2Sz.useGetContentLastModifiedTimestamp)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, issueCreateSidePanelActions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $42omo.useMemo)(()=>pageInfo?.operations?.some((op)=>op?.operation === 'update' && op?.targetType === pageInfo.type) || false, [
        pageInfo
    ]);
    return (0, $42omo.useCallback)(()=>{
        setIsCreatedWithAi(true);
        setIsCreatedFromTable(false);
        setIsRovoPanelWidth(useRovoWidth);
        if (content.current) {
            const range = (0, $1Q0l6.getValidRange)((0, $1Q0l6.getPageContentRange)());
            const payload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), range, content.current, contentLastModifiedTimestamp);
            setInsertStorageFragmentRequestPayload(payload);
        }
        issueCreateSidePanelActions.setHasEditPermission(hasEditPermission);
        rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), useRovoWidth ? (0, $UNr39.ROVO_BULK_CREATE_SIDE_PANEL_WIDTH) : (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    }, [
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        setIsRovoPanelWidth,
        useRovoWidth,
        contentId,
        content,
        contentLastModifiedTimestamp,
        setInsertStorageFragmentRequestPayload,
        issueCreateSidePanelActions,
        hasEditPermission,
        rightSidebarContext
    ]);
};
module.exports["useBulkIssueCreate"] = $c8e282bfad3727e4$export$ddc739fc0aea988a;

});

parcelRegister("eN3MW", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bee98af9586f2941$export$e6e415a985158eb3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EZkxH",
    name: "QuickSummaryStreamingComponent",
    loader: async ()=>(await (parcelRequire("hvPgy"))).QuickSummaryStreamingEntryPoint
});
module.exports["QuickSummaryStreamingComponent"] = $bee98af9586f2941$export$e6e415a985158eb3;

});

parcelRegister("hvPgy", function(module, exports) {

let $cbfd19497b9dc8b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cbfd19497b9dc8b4$var$load("2lYTs"),
    $cbfd19497b9dc8b4$var$load("5JMjw"),
    $cbfd19497b9dc8b4$var$load("kNNS3"),
    $cbfd19497b9dc8b4$var$load("hcY7w"),
    $cbfd19497b9dc8b4$var$load("3Mspc"),
    $cbfd19497b9dc8b4$var$load("6wr18"),
    $cbfd19497b9dc8b4$var$load("i3R6S"),
    $cbfd19497b9dc8b4$var$load("hhss7"),
    $cbfd19497b9dc8b4$var$load("ffEVr"),
    $cbfd19497b9dc8b4$var$load("kUbT8"),
    $cbfd19497b9dc8b4$var$load("jrchu")
]).then(()=>parcelRequire('9zqwo'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("imNHQ", function(module, exports) {
$parcel$export(module.exports, "useOnboardingEntryPointPublish", () => (parcelRequire("jFlMY")).useOnboardingEntryPointPublish);

var $jFlMY = parcelRequire("jFlMY");


});

parcelRegister("kEiOB", function(module, exports) {
/**
 * @generated SignedSource<<e25536290fed122b36627f9024b4fde7>>
 * @relayHash a94de81c04a5ca0ee498c4b43bd0b87e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59579c0cbce680227e7e004f19597a1cb936a924ff0a90d7bde7bec6b2353a3e
const $a276a79892dc32b6$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useViewPageRovoActionsGetUserJobTitleQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useViewPageRovoActionsGetUserJobTitleQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a94de81c04a5ca0ee498c4b43bd0b87e",
            "id": "59579c0cbce680227e7e004f19597a1cb936a924ff0a90d7bde7bec6b2353a3e",
            "metadata": {},
            "name": "useViewPageRovoActionsGetUserJobTitleQuery",
            "operationKind": "query",
            "text": "query useViewPageRovoActionsGetUserJobTitleQuery{user:confluence_atlassianUser(current:true){id,title}}"
        }
    };
}();
$a276a79892dc32b6$var$node.hash = "5161add4babe6275214e15eeadece7c3";
var $a276a79892dc32b6$export$2e2bcd8739ae039 = $a276a79892dc32b6$var$node;


/**
 * @generated SignedSource<<fb708c298556821f744306bbdf95769d>>
 * @relayHash 395e251011979c6ec0b37576c629adf4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 545f1f224d422f5712e13bc313dd14406919d981e1d3bcbe794dee288fc527cb
const $46f1b26718b89325$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cql"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useViewPageRovoActionsGetUserContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useViewPageRovoActionsGetUserContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "395e251011979c6ec0b37576c629adf4",
            "id": "545f1f224d422f5712e13bc313dd14406919d981e1d3bcbe794dee288fc527cb",
            "metadata": {},
            "name": "useViewPageRovoActionsGetUserContentQuery",
            "operationKind": "query",
            "text": "query useViewPageRovoActionsGetUserContentQuery($cql:String!){confluence_search(cql:$cql,first:1){count}}"
        }
    };
}();
$46f1b26718b89325$var$node.hash = "31265bf9905142fd23884b73000d4f58";
var $46f1b26718b89325$export$2e2bcd8739ae039 = $46f1b26718b89325$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $jMyy4 = parcelRequire("jMyy4");


var $kevJM = parcelRequire("kevJM");


var $1yB28 = parcelRequire("1yB28");


var $cUQMr = parcelRequire("cUQMr");


var $dmbve = parcelRequire("dmbve");


var $7ZcJJ = parcelRequire("7ZcJJ");


var $1Zr9M = parcelRequire("1Zr9M");


var $afBrg = parcelRequire("afBrg");


var $iulqN = parcelRequire("iulqN");


var $inPa6 = parcelRequire("inPa6");


var $6Htct = parcelRequire("6Htct");


var $hR4U4 = parcelRequire("hR4U4");


var $8unJx = parcelRequire("8unJx");


var $9s8in = parcelRequire("9s8in");


var $auvZ1 = parcelRequire("auvZ1");


var $9VC5k = parcelRequire("9VC5k");


var $2bR8c = parcelRequire("2bR8c");


var $dWpd3 = parcelRequire("dWpd3");


var $JTIzG = parcelRequire("JTIzG");


var $c8mrj = parcelRequire("c8mrj");


var $3Am3T = parcelRequire("3Am3T");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $4aiCO = parcelRequire("4aiCO");


var $UNr39 = parcelRequire("UNr39");


var $auLW1 = parcelRequire("auLW1");


var $jln20 = parcelRequire("jln20");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $eN3MW = parcelRequire("eN3MW");


var $amW67 = parcelRequire("amW67");


var $bQm3c = parcelRequire("bQm3c");


var $h7YX1 = parcelRequire("h7YX1");








var $8DN9t = parcelRequire("8DN9t");


var $cyLm6 = parcelRequire("cyLm6");





var $3HOqx = parcelRequire("3HOqx");


var $54tpX = parcelRequire("54tpX");


var $6fjxX = parcelRequire("6fjxX");


var $lebfc = parcelRequire("lebfc");


var $6767u = parcelRequire("6767u");


var $f6IRL = parcelRequire("f6IRL");


var $lY7ys = parcelRequire("lY7ys");







/**
 * Internationalized messages for create quick action titles
 */ const $47a9b62f640f57dd$var$i18n = (0, $aXWIB.defineMessages)({
    // Product Management
    defineRequirements: {
        id: "experiment-rovo-chat-create-quick-actions.defineRequirements",
        defaultMessage: "Define product requirements"
    },
    identifyStakeholders: {
        id: "experiment-rovo-chat-create-quick-actions.identifyStakeholders",
        defaultMessage: "Identify key partners"
    },
    gatherInsights: {
        id: "experiment-rovo-chat-create-quick-actions.gatherInsights",
        defaultMessage: "Gather insights"
    },
    // Engineering
    sketchPlan: {
        id: "experiment-rovo-chat-create-quick-actions.sketchPlan",
        defaultMessage: "Sketch out a plan"
    },
    documentDecisions: {
        id: "experiment-rovo-chat-create-quick-actions.documentDecisions",
        defaultMessage: "Document key decisions"
    },
    draftApiDocs: {
        id: "experiment-rovo-chat-create-quick-actions.draftApiDocs",
        defaultMessage: "Draft API guidance"
    },
    // Marketing
    gtmPlan: {
        id: "experiment-rovo-chat-create-quick-actions.gtmPlan",
        defaultMessage: "Map a path to market"
    },
    competitorAnalysis: {
        id: "experiment-rovo-chat-create-quick-actions.competitorAnalysis",
        defaultMessage: "Compare to top competitors"
    },
    contentIdeas: {
        id: "experiment-rovo-chat-create-quick-actions.contentIdeas",
        defaultMessage: "Build up brand visibility"
    },
    // Sales
    discoveryQuestions: {
        id: "experiment-rovo-chat-create-quick-actions.discoveryQuestions",
        defaultMessage: "Start the conversation"
    },
    salesTimeline: {
        id: "experiment-rovo-chat-create-quick-actions.salesTimeline",
        defaultMessage: "Visualize the journey"
    },
    introEmail: {
        id: "experiment-rovo-chat-create-quick-actions.introEmail",
        defaultMessage: "Connect with key deciders"
    },
    // Program Management
    projectPlan: {
        id: "experiment-rovo-chat-create-quick-actions.projectPlan",
        defaultMessage: "Build a phased structure"
    },
    riskAssessment: {
        id: "experiment-rovo-chat-create-quick-actions.riskAssessment",
        defaultMessage: "De-risk the program"
    },
    statusReport: {
        id: "experiment-rovo-chat-create-quick-actions.statusReport",
        defaultMessage: "Reflect on past work"
    },
    // Other/General
    analyzeFeedback: {
        id: "experiment-rovo-chat-create-quick-actions.analyzeFeedback",
        defaultMessage: "Surface any blockers"
    },
    brainstormIdeas: {
        id: "experiment-rovo-chat-create-quick-actions.brainstormIdeas",
        defaultMessage: "Reflect on past work"
    },
    researchPlan: {
        id: "experiment-rovo-chat-create-quick-actions.researchPlan",
        defaultMessage: "Catalog critical assets"
    }
});
const $47a9b62f640f57dd$export$6e4bfac24c98075 = [
    // Product Management
    {
        id: 'define-requirements',
        title: $47a9b62f640f57dd$var$i18n.defineRequirements,
        prompt: 'Create a Confluence page with a PRD for [project]. Include sections for user stories, with acceptance criteria for each story, success metrics (KPIs) for the feature, and technical considerations',
        userJobTitleCategory: 'productManagement',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($54tpX)))
    },
    {
        id: 'identify-stakeholders',
        title: $47a9b62f640f57dd$var$i18n.identifyStakeholders,
        prompt: 'Create a Confluence whiteboard with a stakeholder map for [feature or project], including internal teams (engineering, product, customer success), external partners, and customer segments with influence/interest ratings',
        userJobTitleCategory: 'productManagement',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lebfc)))
    },
    {
        id: 'gather-insights',
        title: $47a9b62f640f57dd$var$i18n.gatherInsights,
        prompt: 'Create a Confluence page with competitive research on [company 1, company 2, company 3]. Focus on recent feature launches, pricing, and compare positioning to our own',
        userJobTitleCategory: 'productManagement',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3HOqx)))
    },
    // Engineering
    {
        id: 'sketch-plan',
        title: $47a9b62f640f57dd$var$i18n.sketchPlan,
        prompt: 'Create a Confluence whiteboard for sprint planning for the upcoming release cycle of [feature or project], listing team members, sprint goals, prioritized backlog items, and story point estimates',
        userJobTitleCategory: 'engineering',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6IRL)))
    },
    {
        id: 'document-decisions',
        title: $47a9b62f640f57dd$var$i18n.documentDecisions,
        prompt: 'Create a Confluence page with an architecture DACI for [recent decision] for [feature or project]',
        userJobTitleCategory: 'engineering',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M)))
    },
    {
        id: 'draft-api-docs',
        title: $47a9b62f640f57dd$var$i18n.draftApiDocs,
        prompt: 'Create a Confluence page with API documentation for [service]. Include details for request parameters, response body (JSON schema), error codes (404, 500), and a cURL example',
        userJobTitleCategory: 'engineering',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($54tpX)))
    },
    // Marketing
    {
        id: 'gtm-plan',
        title: $47a9b62f640f57dd$var$i18n.gtmPlan,
        prompt: 'Create a Confluence page with a GTM launch plan for [feature or project] targeting [audience segment], including key goals, channels, and metrics',
        userJobTitleCategory: 'marketing',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6IRL)))
    },
    {
        id: 'competitor-analysis',
        title: $47a9b62f640f57dd$var$i18n.competitorAnalysis,
        prompt: 'Create a Confluence whiteboard with a market analysis map comparing our [feature or solution] to [competitors]',
        userJobTitleCategory: 'marketing',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6)))
    },
    {
        id: 'content-ideas',
        title: $47a9b62f640f57dd$var$i18n.contentIdeas,
        prompt: 'Create a Confluence page to brainstorm 20 ideas for content targeting [audience] for the awareness funnel stage of [feature or project]. For each, include format, key message, and suggested channel',
        userJobTitleCategory: 'marketing',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6fjxX)))
    },
    // Sales
    {
        id: 'discovery-questions',
        title: $47a9b62f640f57dd$var$i18n.discoveryQuestions,
        prompt: 'Create a Confluence page with 10 discovery questions for a first call with a [buyer persona] at a [industry] company.',
        userJobTitleCategory: 'sales',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6767u)))
    },
    {
        id: 'sales-timeline',
        title: $47a9b62f640f57dd$var$i18n.salesTimeline,
        prompt: 'Create a Confluence whiteboard to diagram a timeline of the sales process for [customer], marking all major touchpoints and interactions',
        userJobTitleCategory: 'sales',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t)))
    },
    {
        id: 'intro-email',
        title: $47a9b62f640f57dd$var$i18n.introEmail,
        prompt: 'Create a Confluence page with an email to a CTO introducing [feature or solution] as a solution, focusing on its value proposition for someone responsible for [area].',
        userJobTitleCategory: 'sales',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lY7ys)))
    },
    // Program Management
    {
        id: 'project-plan',
        title: $47a9b62f640f57dd$var$i18n.projectPlan,
        prompt: 'Create a Confluence page with a project plan highlighting various product management phases, including design, build, test, and release for [program].',
        userJobTitleCategory: 'programManagement',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve)))
    },
    {
        id: 'risk-assessment',
        title: $47a9b62f640f57dd$var$i18n.riskAssessment,
        prompt: 'Create a Confluence page with a risk management checklist for the [program] initiative, identifying potential blockers and providing mitigation strategies',
        userJobTitleCategory: 'programManagement',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6)))
    },
    {
        id: 'status-report',
        title: $47a9b62f640f57dd$var$i18n.statusReport,
        prompt: 'Create a Confluence whiteboard with a retro for the [project or feature] launch with sections for what went well, what did not go as planned, and any key takeaways or action items',
        userJobTitleCategory: 'programManagement',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($54tpX)))
    },
    // Other/General
    {
        id: 'analyze-feedback',
        title: $47a9b62f640f57dd$var$i18n.analyzeFeedback,
        prompt: 'Create a Confluence page to summarize key risks and open questions from [feature or project]',
        userJobTitleCategory: 'other',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6)))
    },
    {
        id: 'brainstorm-ideas',
        title: $47a9b62f640f57dd$var$i18n.brainstormIdeas,
        prompt: 'Create a Confluence whiteboard with a retro board for the upcoming session with my team',
        userJobTitleCategory: 'other',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3HOqx)))
    },
    {
        id: 'research-plan',
        title: $47a9b62f640f57dd$var$i18n.researchPlan,
        prompt: 'Create a Confluence page to set up a content library database for [project or launch] to organize marketing assets and blog posts with fields for asset type, target audience, status, and tags',
        userJobTitleCategory: 'other',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($54tpX)))
    }
];
function $47a9b62f640f57dd$export$6b411a65284a4166(userJobTitleCategory) {
    return $47a9b62f640f57dd$export$6e4bfac24c98075.filter((prompt)=>prompt.userJobTitleCategory === userJobTitleCategory);
}
function $47a9b62f640f57dd$export$e4ec531d963fa87c(prompts, intl) {
    return prompts.map((prompt)=>({
            id: `${prompt.id}-rovo-quick-action`,
            title: intl.formatMessage(prompt.title),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(prompt.icon, {
                    label: ""
                }),
            handleType: (0, $6Htct.HandleActionType).Chat,
            dynamicPrompt: prompt.prompt,
            isChild: true
        }));
}
/**
 * Keyword patterns for each job title category
 */ const $47a9b62f640f57dd$var$JOB_TITLE_KEYWORDS = {
    engineering: [
        'engineer',
        'developer',
        'architect',
        'sre',
        'devops',
        'software',
        'technical lead',
        'tech lead'
    ],
    productManagement: [
        'product manager',
        'product owner',
        'product lead',
        'pm '
    ],
    marketing: [
        'marketing',
        'brand',
        'content',
        'communications',
        'growth'
    ],
    sales: [
        'sales',
        'account executive',
        'account manager',
        'business development',
        'bdr',
        'sdr'
    ],
    programManagement: [
        'program manager',
        'project manager',
        'delivery manager',
        'scrum master',
        'agile coach',
        'pmo'
    ]
};
function $47a9b62f640f57dd$export$8f6d0beb398cb0a0(jobTitle) {
    if (!jobTitle) return 'other';
    const normalizedTitle = jobTitle.toLowerCase();
    // Safe to iterate: fixed set of 5 categories with ~30 total keywords.
    // Not user-controlled data, so no risk of quadratic performance issues.
    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const [category, keywords] of Object.entries($47a9b62f640f57dd$var$JOB_TITLE_KEYWORDS)){
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        if (keywords.some((keyword)=>normalizedTitle.includes(keyword))) return category;
    }
    return 'other';
}
function $47a9b62f640f57dd$export$b1e22b23c90d78ff(jobTitle, intl) {
    const category = $47a9b62f640f57dd$export$8f6d0beb398cb0a0(jobTitle);
    const prompts = $47a9b62f640f57dd$export$6b411a65284a4166(category);
    return $47a9b62f640f57dd$export$e4ec531d963fa87c(prompts, intl);
}


const $7dab2f8a87f7b6ba$var$PROJECT_TITLE_KEYWORDS = [
    'project',
    'overview',
    'poster',
    'brief',
    'scope',
    'plan',
    'launch',
    'strategy'
];
const $7dab2f8a87f7b6ba$var$titleContainsProjectKeyword = (contentTitle)=>{
    const lowerTitle = contentTitle.toLowerCase();
    return $7dab2f8a87f7b6ba$var$PROJECT_TITLE_KEYWORDS.some((keyword)=>lowerTitle.includes(keyword));
};
const $7dab2f8a87f7b6ba$export$f2eec944fba9428e = ({ contentType: contentType, contentTitle: contentTitle })=>{
    if (contentType !== 'page') return false;
    return Boolean(contentTitle && $7dab2f8a87f7b6ba$var$titleContainsProjectKeyword(contentTitle));
};


const $a6bade25d3c467cc$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    pageCatchupMenuItemSubheaderLabel: {
        id: "page-rovo-config-common.menu.item.label.page-catchup-subheader",
        defaultMessage: "See what's changed since your last visit"
    },
    summarizeSectionLabel: {
        id: "page-rovo-config-common.summarize.section.label",
        defaultMessage: "Summarize page"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    },
    actionItemsNudgeMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.action-items-nudge",
        defaultMessage: "Create Jira tasks to track this project"
    },
    actionItemsNudgeMenuItemSubheaderLabel: {
        id: "page-rovo-config-common.menu.item.label.action-items-nudge-subheader",
        defaultMessage: "Assign and track progress instantly"
    },
    audioBriefingMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing",
        defaultMessage: "Listen to page"
    },
    audioBriefingMenuItemLabelWithContentType: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-with-content-type",
        defaultMessage: "Listen to {contentType}"
    },
    audioBriefingContentTypePage: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-page",
        defaultMessage: "page"
    },
    audioBriefingContentTypeBlogPost: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-blogpost",
        defaultMessage: "blogpost"
    },
    audioBriefingContentTypeLiveDoc: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-live-doc",
        defaultMessage: "live doc"
    },
    audioBriefingMenuItemSubheaderLabel: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-subheader",
        defaultMessage: "Get a brief audio summary"
    },
    createNewContentMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.create-new-content",
        defaultMessage: "Create new content"
    },
    createNewContentActionHeading: {
        id: "page-rovo-config-common.menu.item.heading.create-new-content",
        defaultMessage: "Share your idea or start with an example"
    },
    getProjectOverviewMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.get-project-overview",
        defaultMessage: "Get Project Overview"
    },
    draftCommentsMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.draft-comments",
        defaultMessage: "Draft a comment"
    },
    draftCommentsPrompt: {
        id: "page-rovo-config-common.menu.item.prompt.draft-comments",
        defaultMessage: "Suggest a few comments I could leave on this page, then offer to post my chosen one."
    }
});
const $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES = {
    live: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypeLiveDoc,
    page: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypePage,
    blogpost: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypeBlogPost
};
const $a6bade25d3c467cc$var$isValidAudioContentTye = (key)=>key in $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES;
const $a6bade25d3c467cc$export$e0c34800d984dab2 = ()=>{
    const { contentId: contentId, contentType: contentType, contentTitle: contentTitle, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, isUnpublishedDraft: isUnpublishedDraft, isEditorEmpty: isEditorEmpty } = (0, $amW67.useRovoConfigProviderProps)();
    const { userId: userId, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { mode: rovoUiMode, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isRovoChatOpen = rovoUiMode !== undefined;
    const shouldSkipCreateNewContentAction = !isRovoChatOpen || !isLicensed || !isLoggedIn || !(0, $9wGTI.fg)('cc_fd_rovo_chat_create_quick_actions_kill_switch');
    const { data: userContentData, loading: userContentLoading, error: userContentError } = (0, $jMyy4.useQueryInterop)((0, $46f1b26718b89325$export$2e2bcd8739ae039), {
        variables: {
            cql: `type IN ('page', 'blogpost', 'embed', 'whiteboard', 'database') AND creator = '${userId}' AND created >= now('-28d')`
        },
        skip: shouldSkipCreateNewContentAction,
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/page-rovo-config-common"
    });
    const { data: userJobTitleData, error: userJobTitleError } = (0, $jMyy4.useQueryInterop)((0, $a276a79892dc32b6$export$2e2bcd8739ae039), {
        skip: shouldSkipCreateNewContentAction,
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/page-rovo-config-common"
    });
    const hasCreatedContentInLast28Days = (userContentData?.confluence_search?.count ?? 0) > 0;
    const userJobTitle = userJobTitleData?.user?.title ?? null;
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $42omo.useContext)((0, $3Am3T.CommentCountsContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $42omo.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    // Page Catchup action
    const pageCatchupAction = (0, $42omo.useCallback)(()=>({
            id: 'summarize-changes-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemLabel),
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                    label: "",
                    testId: "summarize-changes-ai-action.icon"
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auLW1.PageCatchupComponent), {
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        setIsOpen: ()=>{},
                        contentPath: window.location.pathname,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false,
                        allowCustomFollowUp: true
                    })
            },
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base,
            customFollowUpContext: {
                available: false,
                fetch: ()=>Promise.resolve([])
            },
            nudgeContext: {
                id: 'content-catchup'
            }
        }), [
        formatMessage,
        contentId,
        contentType,
        spaceKey
    ]);
    // Summarize page action
    const quickSummaryAction = (0, $42omo.useCallback)(()=>({
            id: 'summarize-page-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.summarizeSectionLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                    label: "",
                    testId: "summarize-page-ai-action.icon"
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: contentType,
                        lastModifiedDate: lastModifiedDate ?? '',
                        source: "view-page",
                        setIsOpen: ()=>{},
                        contentPath: window.location.pathname,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false,
                        allowCustomFollowUp: true
                    })
            },
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base,
            customFollowUpContext: {
                available: false,
                fetch: ()=>Promise.resolve([])
            },
            nudgeContext: {
                id: 'page-summaries'
            }
        }), [
        formatMessage,
        contentId,
        contentType,
        spaceKey,
        lastModifiedDate
    ]);
    // Summarize comments action
    const commentSummaryAction = (0, $42omo.useCallback)(()=>({
            id: 'summarize-comments-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.inlineCommentsMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    label: ""
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
                        contentId: contentId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auvZ1.FooterCommentsSummaryCombined), {
                        contentId: contentId,
                        contentType: contentType,
                        source: (0, $9VC5k.CommentsSummarySource).Footer,
                        spaceKey: spaceKey,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false
                    }))
            },
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base
        }), [
        formatMessage,
        contentId,
        contentType,
        spaceKey
    ]);
    // Create Jira bulk issues action
    const handleBulkIssueCreate = (0, $c8mrj.useBulkIssueCreate)({
        contentId: contentId,
        content: content,
        useRovoWidth: true
    });
    const onBulkIssueCreate = (0, $42omo.useCallback)(()=>{
        if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
        else handleBulkIssueCreate();
    }, [
        isSidePanelOpen,
        showWarningDialog,
        handleBulkIssueCreate
    ]);
    const actionItemsNudgeAction = (0, $42omo.useCallback)(()=>({
            id: 'action-items-nudge-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.actionItemsNudgeMenuItemLabel),
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.actionItemsNudgeMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmbve))), {
                    label: ""
                }),
            onClick: onBulkIssueCreate,
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base,
            nudgeContext: {
                id: 'action-items-bulk-create' // matches Experience.featureId in CAP backend
            }
        }), [
        formatMessage,
        onBulkIssueCreate
    ]);
    const bulkIssueCreateAction = (0, $42omo.useCallback)(()=>({
            id: 'bulk-issue-create-ai-action',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $a6bade25d3c467cc$export$defe85febe8b728c.bulkWorkItemsCreateMenuItemLabel : $a6bade25d3c467cc$export$defe85febe8b728c.bulkIssueCreateMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
                    label: ""
                }),
            onClick: onBulkIssueCreate,
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base
        }), [
        formatMessage,
        onBulkIssueCreate
    ]);
    // Audio briefing action
    const { openAudioPlayer: openAudioPlayer } = (0, $9s8in.useAudioPlayerStore)();
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const { activeContent: activeContent } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const { audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState } = (0, $JTIzG.useAudioFeatureFlags)();
    const playBriefingImmediately = audioBriefingNudgeExperimentState === (0, $JTIzG.BriefingNudgeExperimentState).NUDGE_AUTOPLAY;
    const onAudioBriefingAction = (0, $42omo.useCallback)(()=>{
        if (!!activeContent) {
            openAudioPlayer(activeContent, {
                playImmediately: playBriefingImmediately
            });
            // Close the Rovo popup or sidebar after clicking
            const isSidebarOrMiniModalOpen = rovoUiMode === (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR || rovoUiMode === (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL;
            if (isSidebarOrMiniModalOpen) // Close sidebar
            toggleConversationAssistantUIMode({
                targetMode: undefined,
                sidebarApi: sidebarApi
            });
        }
    }, [
        activeContent,
        openAudioPlayer,
        playBriefingImmediately,
        rovoUiMode,
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    const audioBriefingAction = (0, $42omo.useCallback)(()=>{
        const key = activeContent?.subType || activeContent?.contentType;
        const contentTypeMessage = key && $a6bade25d3c467cc$var$isValidAudioContentTye(key) ? $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES[key] : undefined;
        const contentTypeLabel = contentTypeMessage ? formatMessage(contentTypeMessage) : '';
        const title = contentTypeLabel ? formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemLabelWithContentType, {
            contentType: contentTypeLabel
        }) : formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemLabel);
        return {
            id: 'audio-briefing-ai-action',
            title: title,
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($afBrg))), {
                    label: ""
                }),
            onClick: onAudioBriefingAction,
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base,
            nudgeContext: {
                id: 'proactive-audio-briefing' // PROACTIVE_AI_AUDIO_BRIEFING in convo-ai
            }
        };
    }, [
        formatMessage,
        onAudioBriefingAction,
        activeContent
    ]);
    const shouldShowAudioBriefingAction = (0, $42omo.useMemo)(()=>!!activeContent && audioBriefingNudgeExperimentState !== (0, $JTIzG.BriefingNudgeExperimentState).CONTROL, [
        activeContent,
        audioBriefingNudgeExperimentState
    ]);
    // Get Project Overview skill action
    const getProjectOverviewAction = (0, $42omo.useCallback)(()=>({
            id: 'get-project-overview-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.getProjectOverviewMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iulqN))), {
                    label: ""
                }),
            handleType: (0, $6Htct.HandleActionType).Skill,
            type: 'skill-action',
            staticPrompt: '/get-project-details'
        }), [
        formatMessage
    ]);
    // Draft comment action
    const draftCommentAction = (0, $42omo.useCallback)(()=>({
            id: 'draft-comment-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.draftCommentsMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                    label: ""
                }),
            handleType: (0, $6Htct.HandleActionType).Chat,
            staticPrompt: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.draftCommentsPrompt)
        }), [
        formatMessage
    ]);
    // Final actions list
    const getViewPageRovoActions = (0, $42omo.useCallback)(()=>{
        const actions = [];
        const isPageOrBlogpost = contentType === 'page' || contentType === 'blogpost';
        // Remove this const and use isEditorEmpty directly on experiment cleanup
        const isGatedEditorEmpty = isEditorEmpty && (0, $6mKj3.expValEquals)('platform_editor_remove_summarise_from_empty_doc', 'isEnabled', true);
        const createNewContentAction = (()=>{
            if (shouldSkipCreateNewContentAction || !(0, $6mKj3.expVal)('cc_fd_rovo_chat_create_quick_actions', 'isEnabled', false)) return null;
            const childrenActions = (0, $47a9b62f640f57dd$export$b1e22b23c90d78ff)(userJobTitle, intl);
            return {
                actionId: 'create-new-content',
                action: {
                    id: 'create-new-content-nested-action',
                    title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.createNewContentMenuItemLabel),
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))), {
                            label: ""
                        }),
                    handleType: (0, $6Htct.HandleActionType).Nested,
                    children: childrenActions,
                    actionHeading: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.createNewContentActionHeading)
                }
            };
        })();
        // Only show create action when content query is not loading and has no error
        const canShowCreateAction = createNewContentAction && !userContentLoading && !userContentError;
        // If user has created content in the last 28 days, show create action as the first item
        if (hasCreatedContentInLast28Days && canShowCreateAction) actions.push(createNewContentAction);
        // needed for space overview since it doesn't have content type
        // also skip for unpublished drafts and empty live docs)
        if (!isPageOrBlogpost || isUnpublishedDraft || isGatedEditorEmpty) {
            // For non-page content types (like whiteboards), always include create action if available
            if (!hasCreatedContentInLast28Days && canShowCreateAction) actions.push(createNewContentAction);
            return actions;
        }
        // Get Project Overview action (top of the list for published pages with project-related title)
        if ((0, $7dab2f8a87f7b6ba$export$f2eec944fba9428e)({
            contentType: contentType,
            contentTitle: contentTitle
        }) && (0, $6mKj3.expVal)('rovo_connie_empty_state_get_project_details_skill', 'isEnabled', false)) actions.push({
            actionId: 'get-project-overview',
            action: getProjectOverviewAction()
        });
        actions.push({
            actionId: 'page-catchup',
            action: pageCatchupAction()
        }, {
            actionId: 'quick-summary',
            action: quickSummaryAction()
        });
        if ((0, $6mKj3.expValEquals)('confluence_rovo_draft_comments', 'isEnabled', true)) actions.push({
            actionId: 'draft-comment',
            action: draftCommentAction()
        });
        // If user has NOT created content in the last 28 days, show create action as the 3rd item (after page-catchup and quick-summary)
        if (!hasCreatedContentInLast28Days && canShowCreateAction) actions.push(createNewContentAction);
        if (shouldShowAudioBriefingAction) actions.push({
            actionId: 'audio-briefing',
            action: audioBriefingAction()
        });
        // Only show comment summary in Rovo button when proactive_comment_summary experiment is disabled
        if ((unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0) && !(0, $6mKj3.expValEquals)('proactive_comment_summary', 'isEnabled', true)) actions.push({
            actionId: 'comment-summary',
            action: commentSummaryAction()
        });
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) actions.push({
            actionId: 'bulk-issue-create',
            action: bulkIssueCreateAction()
        });
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('twcg-948-create-jira-tasks-from-confluence-v2-fg')) actions.push({
            actionId: 'action-items-nudge',
            action: actionItemsNudgeAction()
        });
        return actions;
    }, [
        contentType,
        contentTitle,
        actionItemsNudgeAction,
        bulkIssueCreateAction,
        commentSummaryAction,
        draftCommentAction,
        footerCommentsCount,
        formatMessage,
        getProjectOverviewAction,
        hasCreatedContentInLast28Days,
        intl,
        isUnpublishedDraft,
        isEditorEmpty,
        pageCatchupAction,
        pageMode,
        quickSummaryAction,
        unresolvedInlineCommentsCount,
        audioBriefingAction,
        shouldShowAudioBriefingAction,
        userJobTitle,
        userContentLoading,
        userContentError,
        shouldSkipCreateNewContentAction
    ]);
    const actions = (0, $42omo.useMemo)(()=>getViewPageRovoActions(), [
        getViewPageRovoActions
    ]);
    (0, $42omo.useEffect)(()=>{
        if (userContentError) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'viewPageRovoActions',
                action: 'errored',
                actionSubject: 'fetchUserContent',
                attributes: {
                    error: userContentError?.message || 'Unknown error'
                }
            }
        }).fire();
    }, [
        userContentError,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (userJobTitleError) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'viewPageRovoActions',
                action: 'errored',
                actionSubject: 'fetchUserJobTitle',
                attributes: {
                    error: userJobTitleError?.message || 'Unknown error'
                }
            }
        }).fire();
    }, [
        userJobTitleError,
        createAnalyticsEvent
    ]);
    return actions;
};
module.exports["useViewPageRovoActions"] = $a6bade25d3c467cc$export$e0c34800d984dab2;

});

parcelRegister("jFlMY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i25hX = parcelRequire("i25hX");


var $8unJx = parcelRequire("8unJx");





var $6mKj3 = parcelRequire("6mKj3");


var $dPJCf = parcelRequire("dPJCf");

const $8dfa2b7a6e15b660$var$ENTRY_POINT_PARAM = 'onboardingEntryPoint';
const $8dfa2b7a6e15b660$var$VALID_ENTRY_POINTS = new Set([
    'cc-onboarding-aifc-add',
    'cc-onboarding-aifc-xflow-add',
    'cc-onboarding-skip',
    'cc-onboarding-xflow-skip'
]);
// Module-scope hook that reads the param from React Router's location state — no window access.
const $8dfa2b7a6e15b660$var$useOnboardingEntryPointParam = (0, $dPJCf.createSingleQueryParamHook)($8dfa2b7a6e15b660$var$ENTRY_POINT_PARAM);
function $8dfa2b7a6e15b660$export$601430e697488bdb() {
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const rawValue = $8dfa2b7a6e15b660$var$useOnboardingEntryPointParam();
    const [entryPoint, setEntryPoint] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.UNSAFE_expValNoExposure)('twcg-1387-rovo-in-onboarding-chat', 'isEnabled', false)) return;
        if (!rawValue || !$8dfa2b7a6e15b660$var$VALID_ENTRY_POINTS.has(rawValue)) return;
        setEntryPoint(rawValue);
        // Strip the param from the URL using React Router's history.replace so that
        // React Router's location stays in sync. Passing null removes the key.
        setQueryParams({
            [$8dfa2b7a6e15b660$var$ENTRY_POINT_PARAM]: null
        }, true);
    }, [
        rawValue,
        setQueryParams
    ]);
    return entryPoint;
}


/**
 * @generated SignedSource<<5eca21dd03e10fe95b7c9c7c34a34b8d>>
 * @relayHash 876dd1ed51260d9cbf47835d7194768e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eb3dba15d458b202626bfcea5d65befda4883877fde34e5f6d37d9d15e794364
const $5d573f4f302aac89$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "includeArchivedProjects": false
            }
        },
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "types",
            "value": [
                "ISSUE"
            ]
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v6 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                v7 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraProjectField",
            "kind": "LinkedField",
            "name": "projectField",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v7 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        }
    ], v9 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "jql",
                    "variableName": "jql"
                }
            ],
            "kind": "ObjectValue",
            "name": "issueSearchInput"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "issueType",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v12 = {
        "concreteType": "JiraProjectField",
        "kind": "LinkedField",
        "name": "projectField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v4 /*: any*/ ,
                    v7 /*: any*/ ,
                    v6 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            },
            v10 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRecentJiraProjectAndIssueQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "JiraIssue"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRecentJiraProjectAndIssueQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "876dd1ed51260d9cbf47835d7194768e",
            "id": "eb3dba15d458b202626bfcea5d65befda4883877fde34e5f6d37d9d15e794364",
            "metadata": {},
            "name": "useRecentJiraProjectAndIssueQuery",
            "operationKind": "query",
            "text": "query useRecentJiraProjectAndIssueQuery($cloudId:ID!,$jql:String!){jira{recentItems(cloudId:$cloudId,types:[ISSUE],filter:{includeArchivedProjects:false},first:1){edges{node{__typename,...on JiraIssue{key,summary,webUrl,issueType{name,id},projectField{project{key,name,webUrl,id},id}},...on Node{__isNode:__typename,id}}}},issueSearch(cloudId:$cloudId,issueSearchInput:{jql:$jql},first:1)@optIn(to:\"JiraSpreadsheetComponent-M1\"){edges{node{key,summary,webUrl,issueType{name,id},projectField{project{key,name,webUrl,id},id},id}}}}}"
        }
    };
}();
$5d573f4f302aac89$var$node.hash = "a33e1370319203ffc089816d9591fc30";
var $5d573f4f302aac89$export$2e2bcd8739ae039 = $5d573f4f302aac89$var$node;



var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");

const $4071abc28ad49b8e$var$RecentJiraProjectAndIssueQuery = (0, $5d573f4f302aac89$export$2e2bcd8739ae039);
const $4071abc28ad49b8e$export$933fc8a8f278bec6 = ({ skip: skip })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($4071abc28ad49b8e$var$RecentJiraProjectAndIssueQuery, {
        variables: {
            cloudId: cloudId,
            jql: '(assignee = currentUser() OR creator = currentUser()) AND statusCategory != Done ORDER BY updated DESC'
        },
        skip: !cloudId || skip,
        interopApolloAggClient: true,
        onError: (err)=>{
            (0, $7Sm4c.markErrorAsHandled)(err);
        },
        __callerPackage__: "@confluence/experiment-rovo-onboarding-twcg-1387"
    });
    // Try to use issueSearch first, and fall back to recentItems if issueSearch doesn't return any results (e.g. if user has no issues)
    const recentIssue = data?.jira?.issueSearch?.edges?.[0]?.node ?? data?.jira?.recentItems?.edges?.[0]?.node;
    const issue = {
        key: recentIssue?.key ?? null,
        summary: recentIssue?.summary ?? null,
        webUrl: recentIssue?.webUrl ?? null,
        issueTypeName: recentIssue?.issueType?.name ?? null
    };
    const project = {
        key: recentIssue?.projectField?.project?.key ?? null,
        name: recentIssue?.projectField?.project?.name ?? null,
        webUrl: recentIssue?.projectField?.project?.webUrl ?? null
    };
    return {
        isLoading: loading,
        data: {
            issue: issue,
            project: project,
            hasFullData: !!(issue.key && issue.summary && issue.webUrl && issue.issueTypeName && project.key && project.name && project.webUrl)
        }
    };
};


function $3259932c954525fc$export$aab04bb87c066d56({ skip: skip, skipAifc: _skipAifc }) {
    const { data: { hasFullData: _isXflowUser, issue: _issue, project: _project }, isLoading: isLoading } = (0, $4071abc28ad49b8e$export$933fc8a8f278bec6)({
        skip: skip
    });
    if (skip || isLoading) return null;
    return {};
}


function $44397b39b00727b1$export$9787a22347cf16cb() {
    const entryPoint = (0, $8dfa2b7a6e15b660$export$601430e697488bdb)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { isMiniModalAvailable: isMiniModalAvailable } = (0, $8unJx.useRovoExperienceAPIStore)();
    const hasFiredRef = (0, $42omo.useRef)(false);
    const rovoConfig = (0, $3259932c954525fc$export$aab04bb87c066d56)({
        skip: entryPoint === null,
        skipAifc: entryPoint === 'cc-onboarding-skip' || entryPoint === 'cc-onboarding-xflow-skip'
    });
    // Fire the publish event once the entry point is detected, the mini-modal is available,
    // and the custom actions we plan to show have loaded.
    // hasFiredRef ensures this only happens once per page load.
    (0, $42omo.useEffect)(()=>{
        if (!entryPoint || !isMiniModalAvailable || hasFiredRef.current || rovoConfig === null) return;
        hasFiredRef.current = true;
        publish({
            type: 'chat-new',
            openChatMode: 'mini-modal',
            data: {
                dialogues: []
            },
            source: entryPoint
        });
    }, [
        entryPoint,
        isMiniModalAvailable,
        publish,
        rovoConfig
    ]);
    return rovoConfig;
}
module.exports["useOnboardingEntryPointPublish"] = $44397b39b00727b1$export$9787a22347cf16cb;

});


//# sourceMappingURL=ObjectSidebarControl.acc473fa.js.map
